import { Component } from '@angular/core';

@Component({
	selector: 'google-login-button',
	templateUrl: './google-login-button.component.html',
	styleUrls: ['./google-login-button.component.scss'],
})
export class GoogleLoginButton {}
